import React, { Fragment } from 'react';
// import { useDispatch } from 'react-redux';
import './RetentionModal.scss';
import TextInfo, {
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import SvgIconLabel, {
  SVGICON_LABEL_POSITION,
  SVG_ICON_KIND,
  ICONS_ID,
} from '@bit/gerenciatd.unifiedicons.svg-icon-label';
import SvgIconLoader from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import Modal from '@bit/gerenciatd.unifiedcomponents.modal';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import { sendCMSEvent } from '@bit/gerenciatd.utils.metrics';
import {
  getSummariesOfCommerInfo,
  normalizeSummaryWithWeightToDic,
  getReadyParamsDependsOnDowngrade,
} from '../../utils/productUtils';
import ProductItem, { VARIANT } from '../ProductItem';
import StyckyButtonsBar from './StyckyButtonsBar';
import { showPreventionModal } from '../ProductItem/Utils';
import {
  hiredPreventionTitle,
  hiredTitle,
  MOBILE,
  sureMsgChangeFusion,
  changeSmartphoneConditionText,
  legalInfoChangesText,
  promoSpecialForYouText,
  selectedProductTitle,
  infoActualPromoDeprecated,
} from './constants';

const COMPONENT_NAME = 'retentionmodal';
const COMPONENT_NAME_PREVENTION = 'preventionmodal';

/**
 * Componnte para cargarDentro del modal de retencion Repo Down
 * @param {object} info informacion para el modal
 * @param {object} taggingInfoRetentionModal informacion para el modal
 * @param {boolean} forcedDisabled (opcional) flag para establecer si los
 *       productItems estan en modo des-habilitado
 * @returns {jsx}
 *
 * @Components {null}
 */
const RetentionModal = ({
  info,
  taggingInfoRetentionModal,
  forcedDisabled,
  onClickContinue,
  isPrevention,
  retentionOffer,
}) => {
  // const dispatch = useDispatch();

  const {
    group: repoGroup,
    constants,
    selectedProduct,
    aliasProduct,
    hiredAliasProduct,
    isDowngrade,
    hasClientAlreadyDevice, // flag para indicar si el cliente ya tiene termiinal
    productHiredUnique, // producto contratado
    groupProductHired: hiredGroup, // grupo de productos contratados
    productHiredIsOldCatalogue, // flag para controlar si el producto contratado
    // pertence al antiguo portfolio
    context, // context
    // prpvCode,
    variant, // prpv
  } = info;

  const { device } = context; // dispositivo de visualizacion (context)

  const taggingInfo = {
    ...taggingInfoRetentionModal,
    componentName: COMPONENT_NAME,
  };

  const infoForRetentionModal = info;

  const {
    link: downGradeButtonLink,
    onClick: downgradeOnClick,
  } = getReadyParamsDependsOnDowngrade(
    infoForRetentionModal.isDowngrade,
    showPreventionModal,
    selectedProduct && selectedProduct.dataMap
      ? selectedProduct.dataMap.urlProdCompra
      : '',
    'clic-boton-meinteresa-distri',
    variant
  );

  const downGradeOnclikcHandler = () => {
    if (downgradeOnClick) {
      showPreventionModal(
        context.device,
        taggingInfo,
        infoForRetentionModal,
        forcedDisabled,
        taggingInfo
      );
    }
  };

  let summariesNormalized = '';
  let hiredSummariesNormalized = '';

  if (aliasProduct && hiredAliasProduct) {
    const summaries = getSummariesOfCommerInfo(
      repoGroup[aliasProduct].product.commerInfo
    );
    const hiredSummaries = getSummariesOfCommerInfo(
      hiredGroup[hiredAliasProduct].product.commerInfo
    );

    summariesNormalized = normalizeSummaryWithWeightToDic(
      summaries,
      aliasProduct
    );
    hiredSummariesNormalized = normalizeSummaryWithWeightToDic(
      hiredSummaries,
      hiredAliasProduct
    );
  }
  const taggingInfoModalPrinted = {
    ...taggingInfo,
    // componentName: COMPONENT_NAME,
    event: 'cms-component',
    eventType: 'print-success',
    componentContent: '',
    componentName: retentionOffer ? COMPONENT_NAME_PREVENTION : COMPONENT_NAME,
  };
  sendCMSEvent(taggingInfoModalPrinted);

  const calculatedTaggingInfoCloseModal = {
    ...taggingInfo,
    componentContent: 'cerrar',
    componentName: retentionOffer ? COMPONENT_NAME_PREVENTION : COMPONENT_NAME,
  };
  const hiredProductTitle = retentionOffer ? hiredPreventionTitle : hiredTitle;
  return (
    <Fragment>
      <section className="content container">
        {device === MOBILE && (
          <div className="closeButton">
            <CustomLink
              taggingInfo={calculatedTaggingInfoCloseModal}
              onClick={Modal.hide}
              className="closeButton"
            >
              <SvgIconLabel
                id={ICONS_ID.Cerrar}
                iconSize={18}
                labelSize={16}
                label={sureMsgChangeFusion}
                labelColor={COLOR.WHITE}
                labelPosition={SVGICON_LABEL_POSITION.RIGHT}
                kind={SVG_ICON_KIND.MEDIUM}
                iconColor={COLOR.WHITE}
                SvgIconLoader={SvgIconLoader}
              />
            </CustomLink>
          </div>
        )}
        {device !== MOBILE && (
          <TextInfo
            text={sureMsgChangeFusion}
            kind={KIND_TEXT.SPAN}
            align={ALIGN.CENTER}
            color={COLOR.BLUE}
            size={SIZE.TITLE4}
            fontType={FONT_TYPE.LIGHT}
            className="titulo"
          />
        )}
        {hasClientAlreadyDevice && isDowngrade && !retentionOffer && (
          <div className="content--conditionsSmartphone">
            <SvgIconLabel
              id={ICONS_ID.Informacion}
              iconSize={18}
              labelSize={16}
              label={changeSmartphoneConditionText}
              labelColor={COLOR.GREY_6}
              labelFont={FONT_TYPE.REGULAR}
              labelPosition={SVGICON_LABEL_POSITION.RIGHT}
              kind={SVG_ICON_KIND.SOLID}
              iconColor={COLOR.BLUE}
              SvgIconLoader={SvgIconLoader}
            />
            <TextInfo
              text={legalInfoChangesText}
              kind={KIND_TEXT.SPAN}
              align={ALIGN.LEFT}
              color={COLOR.GREY_5}
              size={SIZE.CAPTION2}
              fontType={FONT_TYPE.REGULAR}
              className="content--conditionsSmartphone--info"
            />
          </div>
        )}
        {retentionOffer && (
          <div className="content--preventionFusion">
            <TextInfo
              text={promoSpecialForYouText}
              kind={KIND_TEXT.SPAN}
              align={ALIGN.LEFT}
              color={COLOR.WHITE}
              size={SIZE.TITLE4}
              fontType={FONT_TYPE.REGULAR}
              backgroundColor={COLOR.PURPLE}
              className="content--preventionFusion--info"
            />
          </div>
        )}
        <div className="content--comparatorContainer">
          <div className="content--comparatorContainer--fusionItem">
            <TextInfo
              text={selectedProductTitle}
              kind={KIND_TEXT.SPAN}
              align={ALIGN.CENTER}
              color={COLOR.GREY_6}
              size={SIZE.TITLE5}
              fontType={FONT_TYPE.LIGHT}
              className="content--comparatorContainer--fusionItem--title"
            />
            <ProductItem
              className="product"
              group={repoGroup}
              taggingInfo={taggingInfo}
              forcedDisabled
            />
          </div>
          <div className="content--comparatorContainer--fusionItem">
            <TextInfo
              text={hiredProductTitle}
              kind={KIND_TEXT.SPAN}
              align={ALIGN.CENTER}
              color={COLOR.GREY_6}
              size={SIZE.TITLE5}
              fontType={FONT_TYPE.LIGHT}
              className="content--comparatorContainer--fusionItem--title"
            />
            <ProductItem
              className="product"
              variant={VARIANT.HIRED}
              group={hiredGroup}
              productHired={productHiredUnique}
              // productHiredIsOldCatalogue={productHiredIsOldCatalogue}
              modifierPrice={
                !productHiredIsOldCatalogue
                && context.userType !== ''
                && hasClientAlreadyDevice === false
                  ? -3
                  : null
              }
              // modifierSmartphoneIncludes={
              //   context.userType !== '' && hasClientAlreadyDevice === false
              //     ? constants.noSmartPhoneIncluded
              //     : null
              // }
              taggingInfo={taggingInfo}
              constants={constants}
              hiredProductWeights={hiredSummariesNormalized}
              dicRepoProductWeights={summariesNormalized}
              forcedDisabled
              retentionOffer={retentionOffer}
            />
            {retentionOffer && (
              <div className="content--comparatorContainer--fusionItem--retentionInfoMessage">
                <SvgIconLabel
                  id={ICONS_ID.Informacion}
                  iconSize={18}
                  labelSize={16}
                  label=""
                  labelColor={COLOR.GREY_6}
                  labelFont={FONT_TYPE.REGULAR}
                  labelPosition={SVGICON_LABEL_POSITION.RIGHT}
                  kind={SVG_ICON_KIND.SOLID}
                  iconColor={COLOR.BLUE}
                  SvgIconLoader={SvgIconLoader}
                />
                <TextInfo
                  text={infoActualPromoDeprecated}
                  kind={KIND_TEXT.SPAN}
                  align={ALIGN.LEFT}
                  color={COLOR.GREY_5}
                  size={SIZE.CAPTION2}
                  fontType={FONT_TYPE.REGULAR}
                  className="content--conditionsSmartphone--info"
                />
              </div>
            )}
          </div>
        </div>
      </section>
      <section className="buttons">
        <StyckyButtonsBar
          taggingInfo={{
            ...taggingInfo,
            componentName: retentionOffer
              ? COMPONENT_NAME_PREVENTION
              : COMPONENT_NAME,
          }}
          taggingInfoClose={calculatedTaggingInfoCloseModal}
          selectedProduct={selectedProduct}
          onClickContinue={onClickContinue}
          downGradeOnclikcHandler={downGradeOnclikcHandler}
          isPrevention={isPrevention}
          context={context}
          retentionOffer={retentionOffer}
          productHired={productHiredUnique}
          componentName={COMPONENT_NAME_PREVENTION}
        />
      </section>
    </Fragment>
  );
};
export default RetentionModal;
